<template>
    <b-alert :variant="variant" dismissible :show="show" @dismissed="show=false" class="alert-top">
        <a v-if="variant === 'danger'" :href="link" class="alert-link"> {{ message }} </a>
        <a v-else> {{ message }} 
          <b-link v-if="link" :to="link" v-on:click="disposeNotification">{{linkDescription}}</b-link>
        </a>
        <ul v-if="showList">
            <li v-for="item in items">
            <b-link :href="item.link" v-on:click="disposeNotification">{{item.msg}}</b-link>
            </li>
        </ul>
    </b-alert>
</template>

<script>
  import { EventBus } from '@/router/bus'

  function defaultData () {
    return {
      show: false,
      showList: false,
      variant: 'info',
      message: '',
      link: null,
      linkDescription: null,
      items: null
    }
  }

  export default {
    data () {
      return defaultData()
    },
    created () {
      EventBus.$on('alert', (data) => {
        this.show = true
        this.variant = data.variant
        this.message = data.message
        this.link = data.link
        this.linkDescription = data.linkDescription
        this.showList = data.errors.length > 0
        this.items = data.errors
      })

      EventBus.$on('notification-close', () => {
        this.disposeNotification()
      })
    },
    methods: {
      disposeNotification () {
        this.show = false
        this.items = []
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

    .alert-top {
        position: absolute;
        top: 58px;
        z-index: 99;
        border-radius: 0;
        margin-left: 1px;
        width: calc(100% - 2px);
    }
</style>



// WEBPACK FOOTER //
// AlertContainer.vue?2401a388